import { useEffect } from "react";
import {
  MdCheckCircle,
  MdError,
  MdWarning,
  MdInfo,
  MdClose,
} from "react-icons/md";

const VARIANTS = {
  success: {
    bg: "bg-green-50 border-green-200 text-green-800",
    icon: <MdCheckCircle className="text-green-600" size={22} />,
  },
  error: {
    bg: "bg-red-50 border-red-200 text-red-800",
    icon: <MdError className="text-red-600" size={22} />,
  },
  warning: {
    bg: "bg-yellow-50 border-yellow-200 text-yellow-800",
    icon: <MdWarning className="text-yellow-600" size={22} />,
  },
  info: {
    bg: "bg-blue-50 border-blue-200 text-blue-800",
    icon: <MdInfo className="text-blue-600" size={22} />,
  },
};

const Notification = ({
  type = "info",
  title,
  message,
  onClose,
  duration = 4000,
}) => {
  useEffect(() => {
    if (!duration) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const variant = VARIANTS[type];

  return (
    <div
      className={`w-full max-w-sm border rounded-xl shadow-lg px-4 py-3 flex gap-3 items-start animate-slide-in ${variant.bg}`}
    >
      {/* ICON */}
      <div className="mt-0.5">{variant.icon}</div>

      {/* CONTENT */}
      <div className="flex-1">
        {title && (
          <h4 className="font-semibold text-sm mb-0.5">
            {title}
          </h4>
        )}
        <p className="text-sm leading-snug">{message}</p>
      </div>

      {/* CLOSE */}
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600 transition"
      >
        <MdClose size={18} />
      </button>
    </div>
  );
};

export default Notification;
